import { Arrangement } from "../arrangement/Arrangement";
import { ZElement } from "../arrangement/ZElement";
import { Konfiguration } from "./Konfiguration";
import { MassRuler } from "./MassRuler";
import { isEmpty } from "lodash";

/**
 * Erweiterung des Zaunplaner-Arrangements für die Torkonfigurator-spezifischen Features und Eigenheiten
 */
export class ArrangementMass extends Arrangement {
  konfiguration: Konfiguration;
  massRuler: MassRuler;
  savedElemente: ZElement[] = [];

  constructor() {
    super();
    this.konfiguration = new Konfiguration(this);
  }

  getBox() {
    const currentElement = this.getCurrentElement();
    const elementBox = currentElement.getBox();
    elementBox.applyMatrix4(currentElement.matrixWorld);
    if (this.konfiguration.isDreifachtor()) {
      const currentElementEinzeltor = this.getCurrentElementEinzeltor();
      const elementBox2 = currentElementEinzeltor.getBox();
      elementBox2.applyMatrix4(currentElementEinzeltor.matrixWorld);
      elementBox.union(elementBox2);
    }
    return elementBox;
  }

  /**
   * Initialisiert Massruler und setzt die Default-Konfiguration
   */
  initMass() {
    if (!this.getCurrentElement()) {
      this.getSegment().addElemente(0, this.createDefaultElement(), 0, 1, -1);
      this.update3d();
      this.konfiguration.setDefault("Workflow");
      this.konfiguration.setDefault("DetailSerie");
      this.konfiguration.setDefault("Position_Einzeltor");
      this.konfiguration.setDefault("AnMauer");
    }

    this.massRuler = new MassRuler();
    APP.on("afterUpdate3d", () => this.massRuler?.updateRuler(this.getSegment()));

    this.setSelectedObjects([this.getCurrentElement()]);

    // Verhindert Warnmeldung zum Start wegen veränderter Pfosten:
    this.updatingPfostenart = true;
    this.update3d();
    this.updatingPfostenart = false;

    (window as any).konf = this.konfiguration;
    (window as any).currentElement = this.getCurrentElement();
  }

  getSegment() {
    return _.first(this.segmente);
  }

  /**
   * Gibt das akutelle Element aus (bei Dreifachtoren das Doppeltor)
   */
  getCurrentElement(): ZElement {
    let elemente = this.getElemente() as ZElement[];
    if (isEmpty(elemente)) elemente = this.savedElemente;
    if (elemente.length > 1) {
      // Dreifachtor
      return elemente.find((element) => element.isDoppeltor) || _.first(elemente);
    } else {
      return _.first(elemente);
    }
  }

  /**
   * Einzeltor-Element in der Szene bei Dreifachtor (sonst null)
   */
  getCurrentElementEinzeltor(): ZElement {
    let elemente = this.getElemente() as ZElement[];
    if (isEmpty(elemente)) elemente = this.savedElemente;
    if (elemente.length > 1) {
      return elemente.find((element) => !element.isDoppeltor);
    }
    return null;
  }

  update3d() {
    const currentElement = this.getCurrentElement();
    if (currentElement) {
      currentElement.torIstFertig = true;
      currentElement.torÖffnungswinkel = STAGE.orthographicMode || APP.isSaving ? 0 : 20;
      const einzeltor = this.getCurrentElementEinzeltor();
      if (einzeltor) {
        einzeltor.torIstFertig = true;
        einzeltor.torÖffnungswinkel = STAGE.orthographicMode || APP.isSaving ? 0 : 20;
      }
      this.setSelectedObjects([currentElement]);
    }
    super.update3d();
  }

  toJSON() {
    const result = super.toJSON() as any;
    result.massKonfiguration = this.konfiguration.toJSON();
    return result;
  }

  fromJSON(json: any = {}) {
    super.fromJSON(json);
    this.konfiguration.fromJSON(json.massKonfiguration);
    if (this.getSegment()) APP.initMass();
    return this;
  }
}
